import { render, staticRenderFns } from "./OnboardingLocation.vue?vue&type=template&id=627fd693&"
import script from "./OnboardingLocation.vue?vue&type=script&lang=ts&"
export * from "./OnboardingLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports